import { TypePolicies } from '@apollo/client';

const userPolicies: TypePolicies = {
  User: {
    fields: {
      fullName: {
        read(_, { readField }) {
          const firstName = readField<string>('firstName');
          const lastName = readField<string>('lastName');
          const email = readField<string>('email');
          return `${firstName || ''} ${lastName || ''}`.trim() || email || '';
        },
      },
      isAdmin: {
        read(_, { readField }) {
          const role = readField<string>('role');
          return role?.toString().toLowerCase() === 'admin';
        },
      },
    },
  },
};

export default userPolicies;
